import { changeShipRateApi } from "./changeShipRateApi";

export const changeShipRateSetData = async (
  lang,
  credintial,
  setMessageResponse,
  cookies,
  setBtnLoader,
  setShipment
) => {
  const response = await changeShipRateApi(credintial, lang, cookies);

  if (response.success) {
    setShipment((prev) => ({ ...prev, data: response.res.data.data }));
    setMessageResponse((prev) => ({
      ...prev,
      success: true,
      message: response.res.data.message,
      isShow: true,
    }));

    setBtnLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
      setBtnLoader(() => false);
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
      setBtnLoader(() => false);
    }
  }
};
